import { render, staticRenderFns } from "./menuAdd.vue?vue&type=template&id=0c50fb88&"
import script from "./menuAdd.vue?vue&type=script&lang=js&"
export * from "./menuAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports